export enum ChatExportStatus {
  PROCESSING = 'Processing',
  READY = 'Ready',
  FAILED = 'Failed',
  EXPIRED = 'Expired'
}

export enum ChatExportEligibility {
  CAN_EXPORT = 'CAN_EXPORT',
  HAS_READY = 'HAS_READY',
  IS_PROCESSING = 'IS_PROCESSING',
  IS_DELETING = 'IS_DELETING',
  NO_PERMISSION = 'NO_PERMISSION',
  HAS_OTHER_PROCESSING = 'HAS_OTHER_PROCESSING',
  INVALID_MONTH = 'INVALID_MONTH'
}

export interface ChatExportTask {
  id: string;
  serviceNumberId: string;
  month: string;
  timeZone: string;
  status: ChatExportStatus;
  stage?: 'queued' | 'preflight' | 'reading' | 'writing' | 'uploading' | 'done';
  ownerName: string;
  completedAt: string;
  expiresAt: string;
  failureReason?: string;
  isDeleting?: boolean;
  cleanupError?: boolean;
  createdAt?: string;
  fileName?: string;
  fileSize?: number;
  totalMessages?: number;
  totalRooms?: number;
}

export interface ChatExportConfig {
  serviceNumberId: string;
  serviceNumberName?: string;
  timeZone: string;
  maxMonth: string;
  canManage: boolean;
}

export interface DownloadGrantResult {
  downloadUrl: string;
  ttlSeconds: number;
  expiresAt: string;
  requestId: string;
}

export interface SubmitChatExportResponse {
  taskId: string;
  status: ChatExportStatus;
}

export interface DeleteChatExportResponse {
  success: boolean;
  isDeleting: boolean;
}
